import { render, staticRenderFns } from "./romaKingdom.vue?vue&type=template&id=4365a753&scoped=true"
import script from "./romaKingdom.vue?vue&type=script&lang=js"
export * from "./romaKingdom.vue?vue&type=script&lang=js"
import style0 from "./romaKingdom.vue?vue&type=style&index=0&id=4365a753&prod&scoped=true&lang=css"
import style1 from "./romaKingdom.vue?vue&type=style&index=1&id=4365a753&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4365a753",
  null
  
)

export default component.exports